<template>
  <div class="radar">

    <div class="radar-labels">
      <div class="label">
        <div class="radar-label-icon radar-label-icon--red" :class="{'orange': this.$parent.userImpactScore.score >= 4}"></div>
        <div class="radar-label-txt">Your Diet</div>
      </div>

      <div class="label">
        <div class="radar-label-icon radar-label-icon--green"></div>
        <div class="radar-label-txt">Planetary <br>Health Diet</div>
      </div>
    </div>

    <div class="radar-container">
      <div class="radar-label-icon" v-for="(label, index) in this.data" :key="index" :class="`icon-${index}`" @click="openModal(label.Impacts)">
        <img src="../assets/icon-info.svg" alt="">
        <div>{{ label.Impacts }}</div>
      </div>
      <div class="radar-chart" ref="chartdiv"></div>
      <div class="radar-bg"></div>
    </div>

    <el-dialog
      :visible.sync="modalIsOpen2"
      width="42.5%"
      :lock-scroll="true"
      center
      v-if="this.currentModalData.length > 0"
      :append-to-body="true"
      ref="modal2"
      >
      <div class="modal-header">
        <img :src="require(`../assets/${this.currentModalData[0].icon}.svg`)" alt="">
        <div class="modal-title" v-if="this.currentModalData[0].Impact_Area != 'Animal Impact'">
          {{ this.currentModalData[0].Impact_Area }} Impact
        </div>
        <div class="modal-title" v-else>
          Animal Impact
        </div>
      </div>
      <div class="modal-body">
        <div v-if="this.currentModalData[0].Impact_Area == 'Animal Impact'" class="modal-heading">The impact on animals</div>
        <div v-else class="modal-heading">The environmental impact</div>
        <p>{{ this.currentModalData[0].General_Factoid }}</p>

        <div class="modal-heading">The human impact</div>
        <p>{{ this.currentModalData[0].Social_Justice_Factoid}}</p>

      </div>
      <span slot="footer" class="dialog-footer">
        <Btn type="primary-green" theme="white" :hasIcon="false" @click="modalIsOpen2 = false">Close Pop-up</Btn>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mealsData from '../data/meals.json'
import impactModalData from '../data/ImpactModal.json'

import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import am4themes_animated from "@amcharts/amcharts4/themes/animated"

import Btn from "@/components/Btn"

import { Dialog } from 'element-ui'

am4core.useTheme(am4themes_animated);

export default {
  name: 'RadarChart2',
  props: ['data'],
  components: {
    'el-dialog': Dialog,
    Btn
  },
  data() {
    return {
      chart: am4core.Sprite,
      allMeals: mealsData,
      modalIsOpen2: false,
      modalData: impactModalData,
      currentModalData: [],
    }
  },
  mounted() {
    this.renderChart()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    renderChart() {
      this.chart = am4core.create(this.$refs.chartdiv, am4charts.RadarChart);

      this.chart.data = this.data
      this.chart.zoomOutButton.disabled = true;
      this.chart.hiddenState.properties.opacity = 0
      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());

      let categoryAxisRanges = categoryAxis.axisRanges.push(new am4charts.CategoryAxisDataItem());
      categoryAxisRanges.visible = true;
      categoryAxisRanges.endCategory = "Land Use";
      categoryAxisRanges.category = "Greenhouse Gases";
      categoryAxisRanges.axisFill = new am4charts.AxisFill();
      categoryAxisRanges.axisFill.fill = "#ACC9DA";
      categoryAxisRanges.axisFill.fillOpacity = 0.1;
      categoryAxisRanges.axisFill.stroke = "#E7EBEE";
      categoryAxisRanges.axisFill.strokeWidth = 1;
      categoryAxisRanges.axisFill.strokeDasharray = 1;
      categoryAxis.axisRanges.template.visible = false;
      categoryAxis.axisRanges.template.axisFill.opacity = 1;
      categoryAxis.visible = true;
      categoryAxis.dataFields.category = "Impacts";

      categoryAxis.fillOpacity = 1;
      categoryAxis.strokeWidth = 1;
      categoryAxis.strokeOpacity = 1;
      categoryAxis.strokeDasharray = 5;
      categoryAxis.strokeDashoffset = 10;
      categoryAxis.opacity = 1;
      categoryAxis.dataItems.template.text = '';

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

      // let valueAxisRanges = valueAxis.axisRanges.push(new am4charts.ValueAxisDataItem());
      valueAxis.hidden = true;
      valueAxis.strictMinMax = false;
      valueAxis.min = 0.1;
      valueAxis.max = 100;
      valueAxis.treatZeroAs = 0.1;
      // valueAxis.treatZeroAs = 1;
      valueAxis.useScientificNotation = true;

      valueAxis.strokeWidth = 0;
      valueAxis.strokeDasharray = 0;

      valueAxis.logarithmic = true;
      // // Prevent axis scaling
      // this.chart.events.on("ready", function() {
      //   valueAxis.min = valueAxis.minZoomed;
      //   valueAxis.max = valueAxis.maxZoomed;
      // });

      let series1 = this.chart.series.push(new am4charts.RadarSeries());
      series1.name = "one";
      series1.id = 1
      series1.dataFields.valueY = "val";
      series1.dataFields.categoryX = "Impacts";

      if (this.$parent.userImpactScore.score < 3) {
        series1.fill = "#ffbbbb";
        series1.stroke = "#FE5C5C";
        series1.fillOpacity = 0.2;
      } else {
        series1.fill = "#FF8D23";
        series1.stroke = "#FF9A23";
        series1.fillOpacity = 0.2;
      }

      let series2 = this.chart.series.push(new am4charts.RadarSeries());
      series2.name = "two";
      series2.id = 2
      series2.dataFields.valueY = "val2";
      series2.dataFields.categoryX = "Impacts";

      series2.fill = "#93ECB7";
      series2.stroke = "#80CA67";
      series2.fillOpacity = 0.2;


      // setTimeout(function () {
      //   for (var i = 0; i < categoryAxis.dataItems.values.length; i++) {
      //     var image = new am4core.Image();
      //     image.width = 20;
      //     image.height = 20;
      //     image.horizontalCenter = "middle"
      //     image.verticalCenter = "middle"
      //     image.href = require('../assets/icon-info.svg')
      //     image.userClassName = 'icon-' + i
      //     // let currentBullet = categoryAxis.dataItems.values[i].bullet
      //
      //     categoryAxis.renderer.labels.values['2'].maxWidth = 80
      //     categoryAxis.renderer.labels.values['2'].wrap = true
      //     categoryAxis.renderer.labels.values['3'].maxWidth = 80
      //     categoryAxis.renderer.labels.values['3'].wrap = true
      //
      //     let img2 = `<img src="${require('../assets/icon-info.svg')}" alt="">`
      //     if (categoryAxis.dataItems.values[i].label) { // Prevents axisRange from getting icon
      //       categoryAxis.dataItems.values[i].label.html = `<div class="info-icon-${i}">${img2}<div>{Impacts}</div></div>`
      //       categoryAxis.dataItems.values[i].dummyData = categoryAxis.dataItems.values[i].label.dataItem.category
      //       categoryAxis.dataItems.values[i].label.wrap = true
      //       categoryAxis.dataItems.values[i].label.marginTop = 20
      //     }
      //   }
      // }, 500);

      // categoryAxis.renderer.labels.template.events.on('hit', (e) => {
      //   this.openModal(e.target.dataItem.category)
      // })

      categoryAxis.renderer.bulletsContainer.x = 20

      categoryAxis.renderer.labels.values[0].zIndex = "9"
      am4core.options.autoSetClassName = true;
    },
    openModal(category) {
      let catConverted
      // let catUnderScored

      if (category == 'Greenhouse Gases') {
        catConverted = 'GHG Emissions'
        // catUnderScored = 'GHG_Emissions'
      } else if (category == 'Nutrient Pollution') {
        catConverted = 'Water Pollution'
        // catUnderScored = 'Water_Pollution'
      } else if (category== 'Biodiversity Loss') {
        catConverted = 'Biodiversity Loss'
        // catUnderScored = 'Biodiversity_Loss'
      } else if (category == 'Animal Impact') {
        catConverted = 'Animal Impact'
        // catUnderScored = 'Animal_Equivalency'
      } else if (category == 'Water Use') {
        catConverted = 'Water Use'
        // catUnderScored = 'Water_Use'
      } else if (category == 'Land Use') {
        catConverted = 'Land Use'
        // catUnderScored = 'Land_Use'
      }
      // this.currentFactoidImpact = catUnderScored
      this.currentModalData = this.modalData[this.region].filter(impact => impact.Impact_Area.includes(catConverted))

      this.modalIsOpen2 = true
      // }
    }
  },
  computed: {
    region() {
      return this.$store.state.Region.region
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/styles/vars';
.el-dialog__headerbtn .el-dialog__close {
  font-size: 16px;
  font-weight: $fwSemiBold;
  color: #797979;
}
.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: $cSecondaryGreen !important;
}
.el-dialog__wrapper {
  // left: initial;
  color: $cBlack;
  @media (min-width: 768px) {
    // left: 50vw;
  }
  p {
    color: $cBlack;
    word-break: break-word;
    font-family: $fPrimary;
    font-weight: $fwReg;
    font-size: 13px;
    line-height: 19px;
    margin-bottom: 32px;
  }
}
.modal-header {
  border-bottom: 1px solid #E5EAED;
  display: flex;
  flex-flow: column;
  align-items: center;
  img {
    margin-bottom: 16px;
  }
}
.modal-body {
  p {
    margin-bottom: 0;
  }
  a {
    margin-top: 10px;
    display: inline-block;
    color: $cSecondaryGreen;
    font-family: $fPrimary;
    font-weight: $fwMed;

  }
}
.modal-title {
  font-family: $fPrimary;
  font-weight: $fwSemiBold;
  font-size: 22px;
  line-height: 27px;
  text-align: center;
  color: $cBlack;
  margin-bottom: 32px;
  word-break: break-word;
}
.modal-heading {
  font-family: $fPrimary;
  font-weight: $fwSemiBold;
  font-size: 15px;
  line-height: 18px;
  margin-top: 32px;
  margin-bottom: 14px;
  color: $cBlack;
  word-break: break-word;
}

.radar {
  margin-top: 40px;
  .radar-chart {
    min-height: 400px;
    max-width: 418px;
    margin: 0 auto;
  }

  .radar-labels {
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    .label {
      display: flex;
      flex-flow: row;
      align-items: center;
      margin-right: 25px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .radar-label-icon {
      transform: rotate(45deg);
      height: 14px;
      width: 14px;
      &--red {
        background: rgba(255, 187, 187, 0.2);
        border: 1px solid #FE5C5C;
        &.orange {
          background: rgba(255, 141, 35, 0.2);
          border: 1px solid #FF9A23;
        }
      }
      &--green {
        background: rgba(147, 236, 183, 0.2);
        border: 1px solid #80CA67;
      }
    }
    .radar-label-txt {
      font-family: $fPrimary;
      font-weight: $fwSemiBold;
      font-size: 13px;
      line-height: 16px;
      margin-left: 12px;
    }
  }

}

</style>


<!-- radarConfig: {
  "type": "RadarChart",
  "fontWeight": "600",
  "fontSize": "13px",
  "fontFamily": "Arial",
  "fill": "#000000",
  "data": [],
  "xAxes": [{
      "type": "CategoryAxis",
      "userClassName": "radar-category-axis",
      "strokeDasharray": "5,10",
      "dataFields": {
        "category": "Impacts"
      },
      "bullets": {
        "type": "bullet",
        "children": [{
          "type": "Rectangle",
          // "href": "../assets/icon-info.svg",
          "width": 30,
          "height": 30,
          "horizontalCenter": "middle",
          "verticalCenter": "middle"
        }]
      },
      "dataItems": {

      },
      "states": {
        "down": {
         "properties": {
           "tooltipPosition": "cursor",
           "tooltipHTML": "<img src='../assets/logo.png' />",
           "showTooltipOn": "hit",
           "isHover": true,
           "interactionsEnabled": true
         }
        }
       },
       "clickable": true,
      "axisRanges": {
        "values": [{
            "type": "CategoryAxisDataItem",
            "grid": {
                "type": "Grid"
            },
            "endCategory": "Land Use",
            "category": "Greenhouse Gases",
            "axisFill": {
                "type": "AxisFill",
                "fill": "#E7EBEE",
                "fillOpacity": 0.1,
                "stroke": "#E7EBEE",
                "strokeWidth": 1,
                "strokeDasharray": "1,1"
            }
        }]
    },
  }],
  "yAxes": [{
      "type": "ValueAxis",
      "id": "y-axis",
      "userClassName": "y-axis",
      "min": 0.001,
      "max": 100000,
      "logarithmic": true,
      "treatZeroAs": 0.000001,
      // "hidden": true,
      "useScientificNotation": true,
      "strokeWidth": 0,
      "strokeDasharray": "0",
      "axisRanges": {
        "template": {
           "type": "ValueAxisDataItem",
           "visible": true
       }
     },
    //  "axisBreaks": [{
    //     "type": "ValueAxisBreak",
    //     "hidden": false,
    //     "startValue": 300,
    //     "endValue": 40000,
    //     "breakSize": ".02",
    //     "defaultState": {
    //       "transitionDuration": 1000,
    //     },
    //     "states": {
    //         "hover": {
    //           "transitionDuration": 1500,
    //             "properties": {
    //                 "isHover": true,
    //                 "hoverable": true,
    //                 "breakSize": 1,
    //                 "opacity": 0.1,
    //                 "horizontalCenter": "none"
    //             }
    //         }
    //     }
    // }],
  }],
  "series": [{
      "type": "RadarSeries",
      "id": 1,
      "name": "one",
      "dataFields": {
          "valueY": "val",
          "categoryX": "Impacts"
      },
      "fillOpacity": 0.2,
      "fill": "#FFBBBB",
      "stroke": "#FE5C5C"
  },
  {
      "type": "RadarSeries",
      "id": 2,
      "name": "two",
      "dataFields": {
          "valueY": "val2",
          "categoryX": "Impacts"
      },
      "fillOpacity": 0.2,
      "fill": "#93ECB7",
      "stroke":"#80CA67"
  }],
} -->
